export const RBC_GIC_CONFIRMATION_BACK_TO_HOMEPAGE_LINK =
  'https://www.applyboard.com/rbc-student-gic-program';
